import { groupBy, reduce } from 'lodash';
import React, { useState } from 'react';
import { Common, useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { ExpandButton } from 'src/domains/sportsbook/webview/components/expandButton/ExpandButton';
import { Selection } from 'src/domains/sportsbook/webview/components/Selection';
import {
    SelectionsGroupLiItem,
    SelectionsGroupName,
} from 'src/domains/sportsbook/webview/components/selectionsGroupUnified/SelectionGroupUnified.style';
import { observer } from 'src/utils/mobx-react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { SelectionList, SelectionsGroup } from './OutrightMarketUnified.style';

const getColumnsCountByTemplateId = (templateId: string, common: Common): number => {
    const breakpointsState = BreakpointsState.get(common);
    const COLUMNS: Record<string, number> = {
        'one-column': 1,
        'two-column': 2,
        'three-column': 3,
    };

    let columsCount = COLUMNS[templateId];

    if (columsCount === undefined || !breakpointsState.largeMobile.isBiggerOrEq) {
        columsCount = 1;
    }

    return columsCount;
};

const getColumns = (selections: Record<number, SelectionModel[]>, columnsCount: number): SelectionModel[][] => {
    const selectionListFirst = Object.values(selections)[0];

    if (selectionListFirst === undefined) {
        return [];
    }

    const selectionsInColumns = groupBy(
        selectionListFirst,
        (_selection) => selectionListFirst.indexOf(_selection) % columnsCount
    );

    return Object.values(selectionsInColumns);
};

interface PropsType {
    selections: Record<string, SelectionModel[]>;
    displayTemplate: string;
    rowsLimit?: number;
    expandable?: boolean;
    showParticipantName?: boolean;
}

export const CustomColumnsLayout = observer('CustomColumnsLayout', (props: PropsType) => {
    const { displayTemplate, selections, expandable = true, rowsLimit = 4, showParticipantName = false } = props;

    const common = useCommon();
    const languagesState = LanguagesState.get(common);

    const columnsCount = getColumnsCountByTemplateId(displayTemplate, common);

    const columns = getColumns(selections, columnsCount);

    const numOfSelections = reduce(columns, (sum, column) => sum + column.length, 0);

    const showExpandButtton = expandable ? rowsLimit * columns.length < numOfSelections : false;

    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <>
            <SelectionsGroup className='selections-group'>
                {columns.map((column, ind) => (
                    <SelectionList key={ind}>
                        {(isExpanded ? column : column.slice(0, rowsLimit)).map((selection) => {
                            const title = languagesState.getSelectionTranslationName(selection);
                            return (
                                <SelectionsGroupLiItem key={selection.id}>
                                    {showParticipantName === false ? (
                                        <SelectionsGroupName title={title}>
                                            <span>{title}</span>
                                        </SelectionsGroupName>
                                    ) : null}
                                    <Selection
                                        selectionId={selection.id2}
                                        participantName={showParticipantName ? title : null}
                                    />
                                </SelectionsGroupLiItem>
                            );
                        })}
                    </SelectionList>
                ))}
            </SelectionsGroup>
            {showExpandButtton ? (
                <ExpandButton
                    isExpanded={isExpanded}
                    toggleExpand={() => setIsExpanded(!isExpanded)}
                    isHomepage={false}
                />
            ) : null}
        </>
    );
});
